export default "__VITE_ASSET__bbe1683b__"